module.exports = __webpack_public_path__ + "img/text.6ffc9e24.png";